import { ISemanticEvent } from '@cp/shared/tracking';

export const withTrack =
  <T extends (...args: never[]) => void, EPayload = void>(
    track: (e: ISemanticEvent<EPayload>) => void,
    eventBuilder: (...args: Parameters<T>) => ISemanticEvent<EPayload>,
    fn: T,
  ) =>
  (...args: Parameters<T>) => {
    try {
      track(eventBuilder(...args));
    } catch (e) {
      console.error(e);
    }
    return fn(...args) as ReturnType<T>;
  };
